import React from "react";
import { makeStyles } from "@material-ui/core";
import { AnnouncementOutlined } from "@material-ui/icons";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  mediaContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "8px",
  },

  mediaIcon: {
    backgroundColor: theme.palette.primary.pastel,
    display: "flex",
    flexDirection: "column",
    alignItens: "center",
    justifyContent: "center",
    padding: "5px",
    borderRadius: "20px",
  },

  mediaText: { fontSize: "1em", opacity: "0.80", useSelect: "none", },
}));

const MediaWithNoUrl = () => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.mediaContainer}>
      <span className={classes.mediaIcon}>
        <AnnouncementOutlined />
      </span>

      <span className={classes.mediaText}>
        {i18n.t("messageNotAvailable.noUrl")}
      </span>
    </div>
  );
};

export default MediaWithNoUrl;
